import type { ParticipationReportGridColDef } from '../../types';

export const symbolColDef: ParticipationReportGridColDef = {
  headerName: 'Symbol',
  field: 'offeringSymbol',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  width: 101,
};
